import { Vertical } from '@gravitate-js/excalibrr'
import { useSchedulePageFilters } from './Context/Filters/SchedulePageFilterContext'
import { SchedulePageFilterProvider } from './Context/Filters/SchedulePageFilterProvider'
import { DriverScheduleGrid } from './DriverSchedule/DriverScheduleGrid'
import { TractorScheduleGrid } from './TractorSchedule/TractorScheduleGrid'

const GridToRender = () => {
  const { viewMode } = useSchedulePageFilters()
  return viewMode === 'driver' ? <DriverScheduleGrid /> : <TractorScheduleGrid />
}

export function Schedule() {
  return (
    <SchedulePageFilterProvider>
      <Vertical className='p-3'>
        <Vertical style={{ height: 'calc(100vh - 200px)' }}>
          <GridToRender />
        </Vertical>
      </Vertical>
    </SchedulePageFilterProvider>
  )
}
